// Set the date we're counting down to
var timeinput = '';
var countDownDate;
var inv ;
function startaction(){
	var timeinputmonth = $('#timevalmon').text(); 
	var timevaldate = $('#timevaldate').text();
	var timevalyear = $('#timevalyear').text();
	var timevalhor = $('#timevalhour').text();
	var timevalmint = $('#timevalmint').text();
	var timevalsec = $('#timevalsec').text();
	timeinput = timeinputmonth+" "+timevaldate+", "+timevalyear+" "+timevalhor+":"+timevalmint+":"+timevalsec;
	countDownDate = new Date(timeinput).getTime();
	inv = setInterval(startcounter, 1000);
}


// Update the count down every 1 second


function startcounter() {

  // Get todays date and time
  var now = new Date().getTime();

  // Find the distance between now an the count down date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Display the result in the element with id="demo"
 // document.getElementById("demo").innerHTML = days + "d " + hours + "h "
//  + minutes + "m " + seconds + "s ";
   document.getElementById("daystxt").innerHTML = days;
   document.getElementById("hourstxt").innerHTML = hours;
  document.getElementById("minttext").innerHTML = minutes;
  document.getElementById("sectxt").innerHTML = seconds;

  // If the count down is finished, write some text
  if (distance < 0) {
    clearInterval(inv);
    document.getElementById("demo").innerHTML = "EXPIRED";
  }
}